module.exports = __webpack_public_path__ + "static/img/astronauta.a72c942.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/astronauta.gif
// module id = 2080
// module chunks = 5